import { ApolloClient, gql } from '@apollo/client';

const TASK_GROUP_KEY_FRAGMENT = gql`
  fragment TaskGroupKeyFragment on Task {
    id
    groupKey
  }
`;

export type GetTaskGroupKey = (taskId: string) => string | null | undefined;

// Defensive safety net at the submission boundary: read `Task.groupKey` from
// the Apollo cache for any form value that might still be a per-occurrence
// Task.id (e.g., stale form state from before the modal was wired, partial
// cache entries from queries that didn't select `groupKey`). The modal-driven
// path normally emits group_keys directly via `keyTaskByGroup`, in which case
// the resolver is a no-op — the lookup returns the same value back.
export default function createTaskGroupKeyResolver(
  client: ApolloClient,
): GetTaskGroupKey {
  return (taskId) => {
    if (!taskId) return undefined;
    const fragment = client.readFragment<{
      id: string;
      groupKey?: string | null;
    }>({
      id: client.cache.identify({ __typename: 'Task', id: taskId }),
      fragment: TASK_GROUP_KEY_FRAGMENT,
    });
    return fragment?.groupKey;
  };
}
